import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivityState } from '@approot/models';

@Component({
  selector: 'app-activity-modal',
  templateUrl: './activity-modal.component.html',
  styleUrls: ['./activity-modal.component.scss']
})
export class ActivityModalComponent implements OnChanges {
  @Input() activityState: ActivityState = 'ACTIVE';

  public ngOnChanges(changes: SimpleChanges) {
    const state: ActivityState = changes.activityState.currentValue;
  }
}
